"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProfiling = exports.DEFAULT_PROFILING_CATEGORIES = void 0;
const PC = "profilecategory";
exports.DEFAULT_PROFILING_CATEGORIES = [
    `${PC}.email`,
    `${PC}.core`,
    `${PC}.demographics`,
    `${PC}.fooddrink`,
    `${PC}.alcohol`,
    `${PC}.clothing`,
    `${PC}.vehicle`,
    `${PC}.entertainment`,
];
const ValidationTypes = [
    "required",
    "require_count",
    "require_all",
    "name",
    "email",
    "yearborn",
    "zip",
];
exports.defaultProfiling = [
    [
        {
            id: "profilecategory.email",
            questions: [
                {
                    type: "EmailQuestion",
                    id: "email",
                    header: { children: "Enter your Email" },
                    validation: {
                        type: "email",
                        message: "Please enter your email",
                    },
                },
            ],
        },
    ],
    [
        {
            id: "profilecategory.core",
            questions: [
                {
                    type: "NameQuestion",
                    id: "name",
                    header: { children: "Please enter your name" },
                    validation: {
                        type: "name",
                        message: "Please enter your name",
                    },
                },
                {
                    type: "PhoneQuestion",
                    id: "phone",
                    header: { children: "Your Phone" },
                    validation: {
                        type: "required",
                        message: "Please enter your phone",
                    },
                },
                {
                    type: "ZipQuestion",
                    id: "zip",
                    validation: {
                        type: "zip",
                        message: "Please enter your zip code",
                    },
                },
            ],
        },
    ],
    [
        {
            id: "profilecategory.demographics",
            questions: [
                {
                    type: "YearBorn",
                    id: "profiling.yearborn",
                    header: {
                        children: "What year were you born?",
                    },
                    validation: {
                        type: "yearborn",
                        message: "Enter year as YYYY format (e.g. 1987)",
                    },
                },
                {
                    type: "SingleSelectQuestion",
                    id: "profiling.gender",
                    header: {
                        children: "Are you?",
                    },
                    options: [
                        { id: "female", label: "Female" },
                        { id: "male", label: "Male" },
                        { id: "nonbinary", label: "Non-binary" },
                        { id: "notsay", label: "Prefer not to say" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.musicsource",
                    header: {
                        children: "How do you most often listen to music (Choose up to 3)?",
                    },
                    options: [
                        { id: "radio", label: "Radio" },
                        { id: "vinyl", label: "Vinyl/Records" },
                        { id: "tapes", label: "Tapes" },
                        { id: "cd", label: "CDs" },
                        { id: "amazon", label: "Amazon Music Unlimited" },
                        { id: "apple", label: "Apple Music" },
                        { id: "pandorafree", label: "Pandora (Free)" },
                        { id: "pandorapaid", label: "Pandora (Paid Subscription)" },
                        { id: "spotifyfree", label: "Spotify (Free)" },
                        { id: "spotifypaid", label: "Spotify (Paid Subscription)" },
                        { id: "tidal", label: "Tidal" },
                        { id: "yt", label: "YouTube (The Main Website/App)" },
                        { id: "ytm", label: "YouTube (Music Streaming Service)" },
                        { id: "none", label: "None of these" },
                    ],
                    validation: {
                        type: "require_count",
                        max: 3,
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.socialusage",
                    header: {
                        children: "Which of these do you use daily?",
                    },
                    options: [
                        { id: "bereal", label: "BeReal" },
                        { id: "discord", label: "Discord" },
                        { id: "facebook", label: "Facebook" },
                        { id: "instagram", label: "Instagram" },
                        { id: "snapchat", label: "Snapchat" },
                        { id: "tiktok", label: "TikTok" },
                        { id: "twitch", label: "Twitch" },
                        { id: "twitter", label: "Twitter" },
                        { id: "none", label: "None of these" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
            ],
        },
    ],
    [
        {
            id: "profilecategory.fooddrink",
            questions: [
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.eaten",
                    header: {
                        children: "Which of the following have you eaten in the last week?",
                    },
                    options: [
                        {
                            id: "casual",
                            label: "A meal from a casual sit-down restaurant (dine-in or takeout)",
                        },
                        {
                            id: "fine",
                            label: "A meal from a fine dining restaurant (dine-in or takeout)",
                        },
                        {
                            id: "delivery",
                            label: "Restaurant food delivered via a service like UberEats",
                        },
                        { id: "mealkit", label: "A meal kit/service I bought" },
                        {
                            id: "fastfood",
                            label: "A meal from a fast food restaurant (dine-in, drive-through or takeout",
                        },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.groceries",
                    header: {
                        children: "When you’re getting groceries which are important to you?",
                    },
                    options: [
                        {
                            id: "craving",
                            label: "What I’m craving",
                        },
                        {
                            id: "healthy",
                            label: "How healthy it is",
                        },
                        {
                            id: "price",
                            label: "What's on sale/affordable",
                        },
                        { id: "local", label: "What is local or organic" },
                        { id: "deliver", label: "What can be delivered" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.drinks",
                    header: {
                        children: "Which of these do you drink on a regular basis?",
                    },
                    options: [
                        {
                            id: "dietsoft",
                            label: "Diet soft drinks",
                        },
                        {
                            id: "water",
                            label: "Bottled/flavored water",
                        },
                        {
                            id: "tea",
                            label: "Tea",
                        },
                        { id: "juice", label: "Fruit or vegetable juice" },
                        { id: "sports", label: "Sports drinks" },
                        { id: "soft", label: "Soft drinks (non-diet)" },
                        { id: "coffee", label: "Coffee/coffee drinks" },
                        { id: "energy", label: "Energy drinks" },
                        { id: "none", label: "None of these" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "TextQuestion",
                    id: "profiling.foodpartner",
                    header: {
                        children: "What food/drink brand or restaurant do you think would be a good partner for an upcoming tour?",
                    },
                    validation: {
                        type: "required",
                        message: "Please tell us a partner brand",
                    },
                },
            ],
        },
        {
            id: "profilecategory.alcohol",
            questions: [
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.alcoholchoice",
                    header: {
                        children: "When you’re drinking, which of these do you tend to drink (check all that apply)?",
                    },
                    options: [
                        {
                            id: "beer",
                            label: "Regular (not light, not craft/import) beer ",
                        },
                        {
                            id: "lightbeer",
                            label: "Light beer",
                        },
                        {
                            id: "importedbeer",
                            label: "Imported or Craft Beer",
                        },
                        { id: "wine", label: "Wine" },
                        { id: "vodka", label: "Vodka (or Vodka Mixed Drinks)" },
                        {
                            id: "whiskey",
                            label: "Whiskey/Bourbon (or Whiskey/Bourbon Mixed Drinks)",
                        },
                        { id: "rum", label: "Rum (or Rum Mixed Drinks)" },
                        { id: "gin", label: "Gin (or Gin Mixed Drinks)" },
                        { id: "tequila", label: "Tequila (or Tequila Mixed Drinks)" },
                        { id: "premiumliquor", label: "A premium liquor" },
                        { id: "cheapliquor", label: "Budget/cheap liquor" },
                        { id: "cider", label: "Hard Cider or Lemonade" },
                        { id: "seltzer", label: "Hard Seltzer" },
                        { id: "none", label: "I don’t drink alcohol" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    id: "profiling.alcoholpartner",
                    type: "TextQuestion",
                    header: {
                        children: "What beer, wine or alcohol brands could you see {artist} partnering with?",
                    },
                    validation: {
                        type: "required",
                        message: "Please tell us a partner brand",
                    },
                },
            ],
        },
        {
            id: "profilecategory.clothing",
            questions: [
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.buyclothing",
                    header: {
                        children: "Which of these do you regularly buy clothes/accessories from?",
                    },
                    options: [
                        {
                            id: "discount",
                            label: "Discount clothing stores",
                        },
                        {
                            id: "mainstream",
                            label: "Mainstream mall clothing stores",
                        },
                        {
                            id: "highend",
                            label: "High end fashion stores",
                        },
                        {
                            id: "onlinemainstream",
                            label: "The online versions of mainstream mall stores",
                        },
                        { id: "walmart", label: "A store like WalMart or Target" },
                        {
                            id: "online",
                            label: "Online-only stores",
                        },
                        {
                            id: "subscription",
                            label: "Online subscription services",
                        },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "TextQuestion",
                    id: "profiling.artistclothing",
                    header: {
                        children: "What clothing, accessories or cosmetics brands would be a good fit for {artist}? This could be any brands you love or ones you associate with {artist}",
                    },
                    validation: {
                        type: "required",
                        message: "Please enter a response",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.beauty",
                    header: {
                        children: "Which of these are true for you in deciding on personal care and beauty products (like cosmetics, fragrances/cologne, teeth whitening, hair styling, shaving)?",
                    },
                    options: [
                        {
                            id: "economical",
                            label: "I usually look for the most economical option",
                        },
                        {
                            id: "premium",
                            label: "I prefer to buy products from premium brands",
                        },
                        {
                            id: "ethics",
                            label: "The company’s values are an important factor in my decision",
                        },
                        {
                            id: "natural",
                            label: "I prefer cosmetics/personal care products that are natural or organic",
                        },
                        {
                            id: "subscription",
                            label: "I use a subscription service (like Dollar Shave Club or Birchbox)",
                        },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
            ],
        },
        {
            id: "profilecategory.vehicle",
            questions: [
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.nextvehicle",
                    header: {
                        children: "Which types of vehicle would you consider getting next?",
                    },
                    options: [
                        { id: "electric", label: "Electric" },
                        { id: "hybrid", label: "Hybrid" },
                        { id: "suv", label: "SUV" },
                        { id: "pickup", label: "Pickup Truck" },
                        { id: "car", label: "Small Car" },
                        { id: "hatchback", label: "Hatchback" },
                        { id: "motorcycle", label: "Motorcycle" },
                        { id: "none", label: "I don’t drive" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.nextvehiclecost",
                    header: {
                        children: "Which of these are likely to describe your next vehicle?",
                    },
                    options: [
                        { id: "budget", label: "Budget/inexpensive" },
                        { id: "highend", label: "Full-Featured/High-End Trim" },
                        { id: "used", label: "Used" },
                        { id: "new", label: "New" },
                        { id: "american", label: "American" },
                        { id: "Import", label: "Import" },
                        { id: "none", label: "I don’t drive" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    id: "profiling.vehiclepartner",
                    type: "Autocomplete",
                    options: [
                        {
                            id: "Acura",
                            label: "Acura",
                        },
                        {
                            id: "Alfa",
                            label: "Alfa",
                        },
                        {
                            id: "Aston Martin",
                            label: "Aston Martin",
                        },
                        {
                            id: "Audi",
                            label: "Audi",
                        },
                        {
                            id: "Bentley",
                            label: "Bentley",
                        },
                        {
                            id: "BMW",
                            label: "BMW",
                        },
                        {
                            id: "Buick",
                            label: "Buick",
                        },
                        {
                            id: "Cadillac",
                            label: "Cadillac",
                        },
                        {
                            id: "Chevy/Chevrolet",
                            label: "Chevy/Chevrolet",
                        },
                        {
                            id: "Chrysler",
                            label: "Chrysler",
                        },
                        {
                            id: "Dodge",
                            label: "Dodge",
                        },
                        {
                            id: "Ferrari",
                            label: "Ferrari",
                        },
                        {
                            id: "FIAT",
                            label: "FIAT",
                        },
                        {
                            id: "Ford",
                            label: "Ford",
                        },
                        {
                            id: "Genesis",
                            label: "Genesis",
                        },
                        {
                            id: "GMC",
                            label: "GMC",
                        },
                        {
                            id: "Honda",
                            label: "Honda",
                        },
                        {
                            id: "HUMMER",
                            label: "HUMMER",
                        },
                        {
                            id: "Hyundai",
                            label: "Hyundai",
                        },
                        {
                            id: "INFINITI",
                            label: "INFINITI",
                        },
                        {
                            id: "Isuzu",
                            label: "Isuzu",
                        },
                        {
                            id: "Jaguar",
                            label: "Jaguar",
                        },
                        {
                            id: "Jeep",
                            label: "Jeep",
                        },
                        {
                            id: "Kia",
                            label: "Kia",
                        },
                        {
                            id: "Lamborghini",
                            label: "Lamborghini",
                        },
                        {
                            id: "Land Rover",
                            label: "Land Rover",
                        },
                        {
                            id: "Lexus",
                            label: "Lexus",
                        },
                        {
                            id: "Lincoln",
                            label: "Lincoln",
                        },
                        {
                            id: "Maserati",
                            label: "Maserati",
                        },
                        {
                            id: "MAZDA",
                            label: "MAZDA",
                        },
                        {
                            id: "Mercedes-Benz",
                            label: "Mercedes-Benz",
                        },
                        {
                            id: "Mercury",
                            label: "Mercury",
                        },
                        {
                            id: "MINI",
                            label: "MINI",
                        },
                        {
                            id: "Mitsubishi",
                            label: "Mitsubishi",
                        },
                        {
                            id: "NISSAN",
                            label: "NISSAN",
                        },
                        {
                            id: "Porsche",
                            label: "Porsche",
                        },
                        {
                            id: "RAM",
                            label: "RAM",
                        },
                        {
                            id: "Rolls-Royce",
                            label: "Rolls-Royce",
                        },
                        {
                            id: "Saab",
                            label: "Saab",
                        },
                        {
                            id: "Saturn",
                            label: "Saturn",
                        },
                        {
                            id: "Scion",
                            label: "Scion",
                        },
                        {
                            id: "smart",
                            label: "smart",
                        },
                        {
                            id: "Subaru",
                            label: "Subaru",
                        },
                        {
                            id: "Suzuki",
                            label: "Suzuki",
                        },
                        {
                            id: "Tesla",
                            label: "Tesla",
                        },
                        {
                            id: "Toyota",
                            label: "Toyota",
                        },
                        {
                            id: "Volkswagen",
                            label: "Volkswagen",
                        },
                        {
                            id: "Volvo",
                            label: "Volvo",
                        },
                    ],
                    header: {
                        children: "What car brand would make a good tour partner?",
                    },
                    validation: {
                        type: "required",
                        message: "Please tell us a partner brand",
                    },
                },
            ],
        },
        {
            id: "profilecategory.entertainment",
            questions: [
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.sparetime",
                    header: {
                        children: "Which of these are things you like to do in your spare time?",
                    },
                    options: [
                        {
                            id: "teamsports",
                            label: "Playing team sports (basketball/soccer/softball, etc.)",
                        },
                        { id: "bar", label: "Going to a bar" },
                        { id: "socialmedia", label: "Checking social media" },
                        { id: "golf", label: "Golf" },
                        { id: "music", label: "Listening to music" },
                        {
                            id: "makingmusic",
                            label: "Playing or creating music (guitar, piano, sequencing, etc.)",
                        },
                        { id: "gaming", label: "Gaming (console or computer)" },
                        { id: "camping", label: "Camping or Fishing" },
                        { id: "crafts", label: "Crafts/Sewing/crocheting" },
                        { id: "astrology", label: "Astrology" },
                        { id: "volunteer", label: "Volunteer/charity work" },
                        { id: "createsocialmedia", label: "Creating social media content" },
                        { id: "reading", label: "Reading" },
                        { id: "tuning", label: "Work on my car/car tuning" },
                        { id: "offroad", label: "Off-roading/overlanding" },
                        { id: "traveling", label: "Traveling" },
                        { id: "home", label: "Home improvement" },
                        { id: "yoga", label: "Yoga" },
                        { id: "cooking", label: "Cooking/baking" },
                        { id: "church", label: "Church/church activities" },
                        { id: "biking", label: "Biking" },
                        { id: "concert", label: "Going to a concert" },
                        { id: "tv", label: "Watching TV/movies/streaming content at home" },
                        { id: "movies", label: "Going to the movies" },
                        { id: "cardio", label: "Running/doing cardio workouts" },
                        { id: "weights", label: "Lifting weights" },
                        { id: "podcast", label: "Listen to podcasts" },
                        { id: "hiking", label: "Hiking" },
                        { id: "watchsports", label: "Watch sports" },
                        { id: "photography", label: "Photography" },
                        { id: "none", label: "None of the above" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "TextQuestion",
                    id: "profiling.hobbybrands",
                    header: {
                        children: "What brands related to your hobbies do you think would be a good sponsor for {artist}? Please share any favorite stores or brands that you think would be a fit!",
                    },
                    validation: {
                        type: "required",
                        message: "Please provide a response",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.watchproviders",
                    header: {
                        children: "You sit down to watch something, which are you likely to be watching?",
                    },
                    options: [
                        { id: "tv", label: "Traditional TV/cable" },
                        { id: "streaming", label: "Streaming Services" },
                        { id: "yt", label: "YouTube" },
                        { id: "shortform", label: "Short Form Video" },
                        { id: "livestream", label: "Twitch or live video platform" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
                {
                    type: "MultipleSelectQuestion",
                    id: "profiling.watchtech",
                    header: {
                        children: "Which of the following do you have?",
                    },
                    options: [
                        { id: "peloton", label: "A piece of “smart” gym equipment" },
                        { id: "crypto", label: "A crypto wallet" },
                        { id: "vr", label: "A VR headset" },
                        { id: "smartwatch", label: "“Wearable” Tech" },
                        { id: "smarthome", label: "“Smart Home” system" },
                        { id: "smartspeaker", label: "Smart Speaker" },
                        { id: "console", label: "Newest generation console" },
                        { id: "none", label: "None of these" },
                    ],
                    validation: {
                        type: "required",
                        message: "Please select at least one item",
                    },
                },
            ],
        },
    ],
];
//# sourceMappingURL=profiling.js.map